
import React from 'react';
import './style.css';

const DisclaimerAgendamento = ({ 
  termsLink = "https://media-storage-sistemas.s3.sa-east-1.amazonaws.com/documentos/SegMedic+-+Termos+de+Uso.pdf",
  privacyLink = "https://media-storage-sistemas.s3.sa-east-1.amazonaws.com/documentos/SegMedic+-+Pol%C3%ADticas+de+Privacidade.pdf",
  phone = "2666-5800",
  whatsappNumber = "5521266665800",
  recaptchaLink = "https://policies.google.com/privacy"
}) => {
  return (
    <div className="agendamento-informativo">
      <p>
        Ao iniciar seu Agendamento, você concorda com os
        <a target={'_blank'} href={termsLink}> Termos de Uso</a> e a
        <a target={'_blank'} href={privacyLink}> Política de Privacidade</a> 
        aplicáveis à plataforma e à Rede de Clínicas SegMedic.
      </p>
      <p>
        Os serviços agendados por esta plataforma não podem ser editados.
        Caso necessário, entre em contato pelo telefone{' '}
        <strong>{phone}</strong> ou via
        <a href={`https://wa.me/${whatsappNumber}`}> WhatsApp</a> para solicitar alterações.
        Cancelamentos ou confirmações devem ser realizados diretamente na <a href={'https://app.segmedic.com.br/sign-in'}>Área do Paciente</a>.
      </p>
      <p>
        A utilização da plataforma é gratuita e aberta a todos os interessados.
        O pagamento dos serviços será realizado somente no momento do atendimento.
      </p>
      <p>
        Esta página é protegida pelo Google reCAPTCHA para garantir que você não é um robô.
        <a href={recaptchaLink}> Saiba mais.</a>
      </p>
    </div>
  );
};

export default DisclaimerAgendamento;